import { render } from "./PrescriptionEditor.vue?vue&type=template&id=7f8e0332&scoped=true"
import script from "./PrescriptionEditor.vue?vue&type=script&lang=js"
export * from "./PrescriptionEditor.vue?vue&type=script&lang=js"

import "./PrescriptionEditor.vue?vue&type=style&index=0&id=7f8e0332&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8e0332"]])

export default __exports__